module.exports = __webpack_public_path__ + "img/kayaking.cd714882.svg";